import { SparxQuestionColours, SparxQuestionFont } from '@sparx/question';

export const getQuestionColours = (examDisplay?: boolean): SparxQuestionColours | undefined =>
  examDisplay ? { textColour: '#000000', filter: 'grayscale(100%)' } : undefined;

export const getQuestionFont = (examDisplay?: boolean): SparxQuestionFont => ({
  fontSize: 30,
  lineHeight: '1.2em',
  fontFamily: examDisplay ? "'Times New Roman', Times, serif" : undefined,
  katexFontSize: examDisplay ? '1.1em' : undefined,
});
